import { useEffect, useMemo } from 'react';
import { PortfolioEngagementEvent } from 'rwl-shared/dist/models/portfolio/UserPortfolioAction';
import { createEngagementQueue, useEngagementQueue } from 'rwl-ui';
import isbot from 'isbot';
import { captureException } from '@sentry/react';

export const ENGAGEMENT_QUEUE_ID = 'rwl:portfolio:session:events';

export const useEnqueueEngagement = () => {
    const { hasQueue, queue } = useEngagementQueue(ENGAGEMENT_QUEUE_ID);

    useEffect(() => {
        if (!hasQueue) {
            createEngagementQueue(ENGAGEMENT_QUEUE_ID, window.sessionStorage);
        }
    }, [hasQueue]);

    return useMemo(() => {
        if (!hasQueue) {
            return {
                enqueue: () => void 0, // if there's no queue then send to a black hole
            };
        }

        return {
            enqueue: (event: PortfolioEngagementEvent) => {
                if (!event.pageUrl) {
                    event.pageUrl = window.location.href;
                }

                // check for bot traffic
                const useragent = window.navigator.userAgent;
                if (useragent && isbot(useragent)) {
                    return;
                }

                // publish the event
                try {
                    queue?.addToQueue(event);
                } catch (e) {
                    console.error(
                        'Failed to publish rwl engagement event',
                        event
                    );
                    captureException(e);
                }
            },
        };
    }, [hasQueue, queue]);
};
